import React from 'react';
import styles from './hotelCardDates.module.css';

type HotelCardDatesProps = {
  datesInfo: string;
};

const HotelCardDates: React.FC<HotelCardDatesProps> = ({ datesInfo }) => (
  <div className={styles.dates}>{datesInfo}</div>
);

export default HotelCardDates;
